<template>
  <div style="cursor: pointer;"
       @click="$emit('clickMethod', category)"
       class="cursor-pointer d-flex flex-column category-item-block padding-10"
       :class="selectedCategory.value === category.value ? 'selected' : ''"
  >
    <div class="position-relative category-item-img-block">
        <img class="category-item-img"  style="width: 96px; height: 96px" :src="category.iconPath" alt="" />
        <div v-if="showCount" class="count-box" :class="category.count === 0 ? 'empty' : ''">
            {{category.count}}
        </div>
    </div>
  <p class="name">
    {{ category.name }}
  </p>
  </div>
</template>
<script>

export default {
  props: ['category', 'clickMethod', 'showCount', 'selectedCategory'],
  data() {
    return {
      dateNow: new Date(),
      backendUrl: process.env.VUE_APP_URL,
    }
  },
  computed: {
    me() {
      return this.$store.getters['user/me']
    }
  },
  methods: {
  },
}
</script>

<style scoped>
.count-box {
  position: absolute;
  left: 10px;
  bottom: 10px;
  background: #006BE6;
  border-radius: 8px;
  color: white;
  font-size: 14px;
  z-index: 99;
  padding: 6px;
  width: 28px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.count-box.empty {
    background: #DADDE5;
    color: #6E7485;
}

.category-item-block{
  width: calc(100% / 4);
}

.enlarge-menu .category-item-block {
  width: calc(100% / 5);
}

.category-item-block * {
  max-width: 100%;
}

.category-item-block p {
  border-radius: 6px;
}
.category-item-img-block{
    position: relative;
    background: #F7F7F7;
    border-radius: 8px;
    overflow: hidden;
    height: 200px;
    width: 100%;
    transition: .3s;
    border: 2px solid #F7F7F7;
}

.category-item-block.selected .category-item-img-block {
    border: 2px solid #006BE6;
    background: #F0F7FF;
}

.category-item-block:hover .category-item-img-block {
    border: 2px solid #006BE6;
    background: #F0F7FF;
}

.category-item-block .name {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  margin: 8px 0;
  color: #40444D;
}

.category-item-img{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
}

@media (max-width: 1324px) {
  .category-item-block {
    width: calc(100% / 4) !important;
  }
}

@media (max-width: 1100px) {
  .category-item-block {
    width: calc(100% / 3) !important;
  }
}

@media (max-width: 768px) {
  .category-item-block {
    width: calc(100% / 2) !important;
  }
}

@media (max-width: 480px) {
  .category-item-block {
    width: 100% !important;
  }
}
</style>
<style>
.category-item-block{
  .VueCarousel {
    .VueCarousel-navigation {
      button {
        width: 32px !important;
        height: 48px !important;
        top: 75px !important;
        background: rgba(0, 0, 0, .25) !important;
        transform: none !important;
      }
    }

    .VueCarousel-slide.VueCarousel-slide-active{
      display: contents;
      opacity: 1;
    }
    .VueCarousel-slide{
      opacity: 0;
      //width: 100%;
    }



    .VueCarousel-pagination {
      .VueCarousel-dot-container {
        width: 100%;
        background: transparent;
        height: fit-content !important;
        position: absolute;
        right: 0;
        left: 0;
        bottom: 6px;
        margin: 0 auto !important;
        display: flex;
        justify-content: space-between; /* Spread buttons evenly */
        align-items: center;

        button {
          margin: 0 4px !important;
          flex: 1 1 auto; /* Allow each button to grow and shrink equally */
          max-width: 100%; /* Ensure buttons don’t exceed the container width */
          height: 2px !important;
          background: #EDEFF2;
          padding: 0 1px !important;
          border-radius: 0 !important;
        }

        .VueCarousel-dot--active {
          height: 4px !important;
          background: #006BE6 !important;
        }
      }
    }
  }
}
</style>

